// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Privacy & data  ("Download my data" — used by pages/Account and pages/PrivacyData)
// Everything ZenFresh holds for the signed-in account, assembled from the same APIs the site uses and saved as one JSON file in the
// browser. Immediate: nothing is emailed or queued. Device-local choices (favourite categories, cookie/consent switches) are not on the
// server and so are not in the file.
// ─────────────────────────────────────────────────────────────────────────────
import { fetchAddresses } from "./addresses";
import { fetchClaims } from "./claims";
import { fetchErasure } from "./dataRequests";
import { fetchFavouriteCatches } from "./favouriteCatches";
import { fetchOrders } from "./orders";
import { fetchProfile } from "./profile";
import { fetchWallet } from "./wallet";

export async function downloadMyData(): Promise<void> {
  const [profile, addresses, orders, wallet, favouriteCatches, claims, erasure] = await Promise.all([
    fetchProfile(),
    fetchAddresses(),
    fetchOrders(),
    fetchWallet(),
    fetchFavouriteCatches(),
    fetchClaims(),
    fetchErasure(),
  ]);
  const blob = new Blob(
    [
      JSON.stringify(
        {
          exportedAt: new Date().toISOString(),
          note: "Your ZenFresh account data. Choices stored only on your device (favourite categories, cookie and message preferences) are not included.",
          profile,
          addresses,
          orders,
          wallet,
          favouriteCatches,
          complaints: claims.claims,
          erasureRequest: erasure.request,
        },
        null,
        2,
      ),
    ],
    { type: "application/json" },
  );
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `zenfresh-my-data-${new Date().toISOString().slice(0, 10)}.json`;
  link.click();
  URL.revokeObjectURL(link.href);
}
